import {isUndefined} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FormattingUrlDialog} from './formattingUrlDialog';

/*
 * Props.
 */

interface FormattingImageDialogProps {
  url: string | undefined;
  onUrlChange: (arg: string | undefined) => void;
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const FormattingImageDialog: FC<FormattingImageDialogProps> = (props) => (
  <FormattingUrlDialog
    {...props}
    title={renderTitle(isUndefined(props.url))}
    label={<Trans id="formatting-label-insertimage">Paste an image URL</Trans>}
  />
);

function renderTitle(isInserting: boolean) {
  if (isInserting) {
    return <Trans id="formatting-insertimage">Insert inline image</Trans>;
  }

  return <Trans id="formatting-updateimage">Update inline image</Trans>;
}
